
import AttendResultList from './AttendResultList';

export default AttendResultList;
